import { render, staticRenderFns } from "./NodePanel.vue?vue&type=template&id=63abe41a&scoped=true"
import script from "./NodePanel.vue?vue&type=script&lang=js"
export * from "./NodePanel.vue?vue&type=script&lang=js"
import style0 from "./NodePanel.vue?vue&type=style&index=0&id=63abe41a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63abe41a",
  null
  
)

export default component.exports